module.exports = __webpack_public_path__ + "static/media/server.7cf643ee.svg";